/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Workflow_SubtitleInputs */

const zh_landing_workflow_subtitle = /** @type {(inputs: Landing_Workflow_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`四步走，告别表格。教学里那些枯燥的部分，统统自动化。`)
};

const en_landing_workflow_subtitle = /** @type {(inputs: Landing_Workflow_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Four steps. Zero spreadsheets. The boring parts of teaching, automated.`)
};

const es_landing_workflow_subtitle = /** @type {(inputs: Landing_Workflow_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuatro pasos. Cero hojas de cálculo. Las partes aburridas de enseñar, automatizadas.`)
};

/**
* | output |
* | --- |
* | "Four steps. Zero spreadsheets. The boring parts of teaching, automated." |
*
* @param {Landing_Workflow_SubtitleInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_workflow_subtitle = /** @type {((inputs?: Landing_Workflow_SubtitleInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Workflow_SubtitleInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_workflow_subtitle(inputs)
	if (locale === "en") return en_landing_workflow_subtitle(inputs)
	return es_landing_workflow_subtitle(inputs)
});